import { SigningControlJournalParams } from "@interfaces/signing-control";

export const signingControlJournalQueryKeys = {
  all: ["signing-control-journal"],
  journal: (params: SigningControlJournalParams) => [
    ...signingControlJournalQueryKeys.all,
    params,
  ],
};
